import React, { useState, useMemo } from "react";
import { Controlled as CodeMirror } from "react-codemirror2";
import CSVTable from "../csv-table/csv-table";


const RemoteViewer = ({ uri, codeMirror = true }) => {
  const [content, setContent] = useState("Processing...");
  const isCSV = () => uri.match(/\.csv/) && content != "Error fetching file";

  useMemo(() => {
    fetch(uri)
      .then((resp) => resp.text())
      .then((body) => {
        if ((body && body.startsWith("{")) || body.startsWith("[")) {
          try {
            var bodyJson = JSON.parse(body);
            var str = JSON.stringify(bodyJson, null, 2); // spacing level = 2
            body = str;
          } catch (e) {
            // error
          }
        }
        setContent(body);
      })
      .catch((err) => {
        setContent("Error fetching file");
        console.debug(err);
      });
  }, [uri]);

  if (isCSV()) return <CSVTable value={content} />;
  if (codeMirror) return <CodeMirror value={content} />;
  return <pre>{content}</pre>;
};

export default RemoteViewer;
